export var ALERT_VARIANT;
(function (ALERT_VARIANT) {
    ALERT_VARIANT["ERROR"] = "ERROR";
    ALERT_VARIANT["ERROR_BOLD"] = "ERROR_BOLD";
    ALERT_VARIANT["INFO"] = "INFO";
    ALERT_VARIANT["INFO_BOLD"] = "INFO_BOLD";
    ALERT_VARIANT["WARNING"] = "WARNING";
    ALERT_VARIANT["WARNING_BOLD"] = "WARNING_BOLD";
    ALERT_VARIANT["SUCCESS"] = "SUCCESS";
    ALERT_VARIANT["SUCCESS_BOLD"] = "SUCCESS_BOLD";
})(ALERT_VARIANT || (ALERT_VARIANT = {}));
//# sourceMappingURL=AlertVariantEnum.js.map